import React from 'react';
import {
  Wrapper,
  Image,
} from '../common';
import { toKebabCase } from '../../util/helpers';
import './PostImageSet.scss';

const PostImageSet = (props) => {
  const {
    data,
  } = props;
  const {
    primary,
    items: imageSet,
  } = data;
  const {
    imageStyle,
  } = primary;
  const classes = `image-style-${toKebabCase(imageStyle)}`;
  return (
    <section className="post-image-set">
      <Wrapper isBound>
        <div className="image-set">
          { imageSet.map((imageSetItem) => {
            const {
              imageCaption,
              image,
            } = imageSetItem;
            return (
              <div
                className={`image-set-item ${classes}`}
                key={image.url}
              >
                <div className="image-container">
                  <Image image={image} />
                </div>
                <span className="caption">{imageCaption.text}</span>
              </div>
            );
          })}
        </div>
      </Wrapper>
    </section>
  );
};

export default PostImageSet;
